export const PAGE_TITLE = "A Course in Miracles (ACIM)";

export const PAGE_TEXT =
  "<b>A Course in Miracles (ACIM)</b> is a self-study spiritual text that provides teachings on forgiveness, love, and the transformation of perception. It is designed to help individuals achieve inner peace by shifting their thoughts from fear to love, which it describes as the true essence of reality. Scribed by Helen Schucman, who claimed the material was dictated to her by an inner voice she identified as Jesus Christ, the book was first published in 1976.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1QFjm8NjlCfHUNEKP2yOFebBhk1A6lCrP/preview";

export const BREADCRUMB_LABEL = "Lesson's Dashboard";

export const FOOTER_TEXT =
  "All quotes are from A Course in Miracles, Third Edition, copyright © 2007 by the Foundation for Inner Peace, copyright holder and publisher, 448 Ignacio Blvd., #306, Novato, CA 94949, acim.org, used with permission.";
